import {
    CERTIFICATION_STATUS_EXPIRED,
    CERTIFICATION_STATUS_EXPIRING,
    CERTIFICATION_STATUS_VALID
} from '@@utils/certifications';

import type { CertificationStatus } from './types';

import styles from './styles.module.scss';

export const TEST_ID = 'certificationStatusPill';

const STATUS_CLASS_MAP: Record<string, string | undefined> = {
    [CERTIFICATION_STATUS_EXPIRED]: styles.expired,
    [CERTIFICATION_STATUS_EXPIRING]: styles.expiring,
    [CERTIFICATION_STATUS_VALID]: styles.valid
};

// A pill with no status keeps the neutral look, which is what the overflow count
// in the members list uses.
export const getStatusClass = (status?: CertificationStatus): string =>
    status ? (STATUS_CLASS_MAP[status] ?? '') : '';
